<template>
    <div class="modal fade" id="save-offer-file" tabindex="-1" role="dialog" aria-labelledby="save-offer-fileLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content p-4">
                <form method="POST" :action="saveStudentOfferUrl" class="my-4">
                    <input type="hidden" name="_token" :value="csrfToken">
                    <div v-html="courseDetailsFields"></div>
                    
                    <div class="form-group">
                        <input 
                            name="name" 
                            value="" 
                            type="text" 
                            :placeholder="tra.full_name"
                            class="form-control rounded-10 border px-3 btn-light"
                        >
                        <small v-if="postErrors.name" class="text-danger">
                            ( {{ postErrors.name[0] }} )
                        </small>
                    </div>
                    
                    <div class="form-group">
                        <input 
                            name="email" 
                            value="" 
                            type="email" 
                            :placeholder="tra.email_address"
                            class="form-control rounded-10 border px-3 btn-light"
                        >
                        <small v-if="postErrors.email" class="text-danger">
                            ( {{ postErrors.email[0] }} )
                        </small>
                    </div>
                    
                    <button 
                        type="submit"
                        class="btn rounded-10 bg-secondary-color w-100 text-center mb-3 text-white"
                    >
                        {{ tra.save }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SaveOfferModal',
    props: {
        saveStudentOfferUrl: String,
        csrfToken: String,
        courseDetailsFields: String,
        postErrors: Object,
        tra: Object,
    },
};
</script>